import axios, { AxiosRequestConfig, CreateAxiosDefaults } from "axios";
import config from "../config";
import { getWhoAmIToken ,getAuthTokenDMS} from "../utility/utils";
import { store } from "../store/store";
import { showLoader } from "../redux/reducer/commonReducer";
const {Subscription} =config;
const options: any = {
	baseURL: config.BASE_URL,
	timeout: 60000,
	withCredentials: true,
};
const instance = axios.create(options);
// Add a request interceptor
instance.interceptors.request.use(
	async (config: any) => {
		const authData = getAuthTokenDMS();
		const tokenData =  getWhoAmIToken();
		if (tokenData) {
			config.headers["Authorization"] = `Bearer ${tokenData}`;
			config.headers["Subscription"] = Subscription;
		}

		if (!config.headers["Content-Type"]) {
			config.headers["Content-Type"] = "application/json";
		}
		config.headers["Access-Control-Allow-Credentials"] = true;
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Add a response interceptor
instance.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		const originalRequest = error?.config;
		if (error?.response?.status === 401) {
			if (
				originalRequest.url &&
				originalRequest.url?.indexOf("identity") != -1
			) {
				//do nothing
			} else {
				store.dispatch(showLoader({ isLoader: false }));
			}
			return Promise.reject(error);
		}

		return Promise.reject(error);
	}
);

/// new jobcard

const instanceForNewJobcard = axios.create(options);
// Add a request interceptor
instanceForNewJobcard.interceptors.request.use(
	async (config: any) => {
	
		const tokenData = getWhoAmIToken();
		if (tokenData) {
			config.headers["Authorization"] = `ApiKeyAuth`;
			config.headers["Subscription"] =  Subscription;
			config.headers["x-app-id"] = '919b3662-f5f4-473b-8e1f-443401eb06f9';
			config.headers["x-api-key"] = '64192ba1-6292-4095-977f-6925e2f0e544'
		}

		if (!config.headers["Content-Type"]) {
			config.headers["Content-Type"] = "application/json";
		}
		config.headers["Access-Control-Allow-Credentials"] = true;
		return config;
	},
	(error) => {
		return Promise.reject(error);
	}
);

// Add a response interceptor
instanceForNewJobcard.interceptors.response.use(
	(response) => {
		return response;
	},
	async (error) => {
		const originalRequest = error?.config;
		if (error?.response?.status === 401) {
			if (
				originalRequest.url &&
				originalRequest.url?.indexOf("identity") != -1
			) {
				//do nothing
			} else {
				store.dispatch(showLoader({ isLoader: false }));
			}
			return Promise.reject(error);
		}

		return Promise.reject(error);
	}
);

export const Get = (url: string, config?: AxiosRequestConfig<any>) => {
	return new Promise((resolve, reject) => {
		instance
			.get(url, config)
			.then((result) => {
				if (result.status === 200) {
					resolve(result.data);
				} else {
					reject(result.data);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const Put = (url: string, data?: any, config?: AxiosRequestConfig<any>) => {
	return new Promise((resolve, reject) => {
		instance
			.put(url, data, config)
			.then((result) => {
				if (result.status === 200) {
					resolve(result.data);
				} else {
					reject(result.data);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const Post = (url: string, data?: any, config?: AxiosRequestConfig<any>) => {
	return new Promise((resolve, reject) => {
		instance
			.post(url, data, config)
			.then((result) => {
				if (result.status === 200 || result.status === 201) {
					resolve(result.data);
				} else {
					reject(result.data);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const Delete = (url: string, data?: any, config?: AxiosRequestConfig<any>) => {
	return new Promise((resolve, reject) => {
		instance
			.delete(url, config)
			.then((result) => {
				if (result.status === 200) {
					resolve(result.data);
				} else {
					reject(result.data);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const PostForJobCard = (url: string, data?: any, config?: AxiosRequestConfig<any>) => {
	return new Promise((resolve, reject) => {
		instanceForNewJobcard
			.post(url, data, config)
			.then((result) => {
				if (result.status === 200 || result.status === 201) {
					resolve(result.data);
				} else {
					reject(result.data);
				}
			})
			.catch((error) => {
				reject(error);
			});
	});
};

export const API = {
	Get,
	Put,
	Post,
	Delete,
	PostForJobCard
};